import { apiRequest } from '@/utils/api-request';
import {
  CreateOrganizationUrlRequest,
  CreateOrganizationUrlResponse,
  DeleteOrganizationUrlResponse,
  OrganizationUrlsResponse,
} from '@/types/composer-dashboard';

interface AgenticOrg {
  id: string;
  name: string | null;
}

interface AgenticOrgsResponse {
  organizations: AgenticOrg[];
}

export async function getAgenticOrganizations(): Promise<AgenticOrgsResponse> {
  const response = await apiRequest<AgenticOrgsResponse>({
    url: '/api/v1/admin/config/organizations',
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch organizations');
  }

  return response.data;
}

export async function getPostHogUrls(
  orgId: string,
): Promise<OrganizationUrlsResponse> {
  const response = await apiRequest<OrganizationUrlsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/config/posthog-urls`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch PostHog URLs');
  }

  return response.data;
}

export async function createPostHogUrl(
  orgId: string,
  data: CreateOrganizationUrlRequest,
): Promise<CreateOrganizationUrlResponse> {
  const response = await apiRequest<CreateOrganizationUrlResponse>({
    url: `/api/v1/orgs/${orgId}/admin/config/posthog-urls`,
    method: 'POST',
    target: 'workflow',
    body: data,
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to create PostHog URL');
  }

  return response.data;
}

export async function deletePostHogUrl(
  orgId: string,
  urlId: string,
): Promise<DeleteOrganizationUrlResponse> {
  const response = await apiRequest<DeleteOrganizationUrlResponse>({
    url: `/api/v1/orgs/${orgId}/admin/config/posthog-urls/${urlId}`,
    method: 'DELETE',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to delete PostHog URL');
  }

  return response.data;
}
